import { Button } from "@/components/ui/button";
import { CATEGORY_CONFIGS } from "@/types/parameters.types";
import type { ParameterCategory } from "@/types/parameters.types";

interface CategoryPickerProps {
  disabledCategories: ParameterCategory[];
  onSelect: (category: ParameterCategory) => void;
  onCancel: () => void;
}

export function CategoryPicker({ disabledCategories, onSelect, onCancel }: CategoryPickerProps) {
  return (
    <div className="space-y-2 rounded-md border bg-muted/20 p-3">
      <h4 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        Escolha o tipo de parâmetro
      </h4>
      <ul className="space-y-1.5">
        {CATEGORY_CONFIGS.map((cfg) => {
          const disabled = disabledCategories.includes(cfg.category);
          return (
            <li key={cfg.category}>
              <button
                type="button"
                disabled={disabled}
                onClick={() => onSelect(cfg.category)}
                // Texto branco no hover (token pareado accent-foreground);
                // fundo hover:bg-accent inalterado. Descrição muted também vira branca via group.
                className="group w-full rounded-md border border-input px-3 py-2 text-left text-sm transition-colors hover:bg-accent hover:text-accent-foreground disabled:cursor-not-allowed disabled:opacity-50"
                title={disabled ? "Esta máquina já tem 1 parâmetro de Status" : undefined}
                aria-disabled={disabled}
              >
                <p className="font-medium">{cfg.label}</p>
                <p className="text-xs text-muted-foreground group-hover:text-accent-foreground">
                  {cfg.description}
                </p>
              </button>
            </li>
          );
        })}
      </ul>
      <div className="flex justify-end border-t pt-2">
        <Button size="sm" variant="ghost" onClick={onCancel}>
          Cancelar
        </Button>
      </div>
    </div>
  );
}
